import * as R from 'ramda'
import React from 'react'
import { Question } from '../Question/Question'
import { List } from 'components/shared/List/List'

export const Questions = ({ questions, isWordDoc }) => {
  const mapIndexed = R.addIndex(R.map)

  return (
    <List direction="column">
      {mapIndexed(
        ({ description, id, title }, index) => (
          <Question {...{ title, description, index, isWordDoc }} key={id} />
        ),
        questions,
      )}
    </List>
  )
}
